export const PRODUCT_INFO = {
  name: 'Home Warranty Plan',
  phone: '855-573-9261',
} as const;
